/**
 * Checks if the provided object complies with the Storage API.
 * @param {Storage} obj - The object to check for compliance.
 * @returns {boolean} True if the object complies with the Storage API, false otherwise.
 */
export function checkStorageApiCompliance(obj: Storage): boolean {
  return (
    typeof obj.setItem === 'function' &&
    typeof obj.getItem === 'function' &&
    typeof obj.removeItem === 'function' &&
    typeof obj.clear === 'function' &&
    typeof obj.key === 'function' &&
    typeof obj.length === 'number'
  )
}

/**
 * Checks if the provided storage is available and functional.
 * This is done by attempting to set and remove a test key.
 * @param {Storage} storage - The storage object to check.
 * @returns {boolean} True if the storage is available, false otherwise.
 */
export function isStorageAvailable(storage: Storage): boolean {
  try {
    const testKey = '__test__'
    storage.setItem(testKey, 'test')
    storage.removeItem(testKey)
    return true
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return false
  }
}

export function getCookieClient(cookieName: string): string | null {
  if (!import.meta) return null
  return (
    document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${cookieName}=`))
      ?.split('=')[1] || null
  )
}
